<template>
  <div>
    <jump-header />
    <div class="page-body">
      <div class="header" :style="bgImageStyle">
        <div class="filter"></div>
        <div class="anchor">
          <div class="anchor-top">
            <img :src="anchorDetail.publicImage" alt="" />
            <div class="anchor-info">
              <div class="anchor-name">{{ anchorDetail.nickname }}</div>
              <span class="anchor-info-confirm">
                <i class="v-icon-confirm" />
                <span>广州电台主播认证</span>
              </span>
              <div class="options-btn">
                <div class="btn" @click="showDownloadAppToast">私信</div>
                <div class="btn" @click="showDownloadAppToast">+ 关注</div>
              </div>
            </div>
          </div>
          <span class="anchor-desc">
            {{ anchorDetail.description }}
          </span>
          <div class="anchor-options">
            <div class="anchor-options-item" @click="showDownloadAppToast">
              <span class="item-num">{{ anchorDetail.sumFocus }}</span>
              <span class="item-desc">关注</span>
            </div>
            <div class="anchor-options-item" @click="showDownloadAppToast">
              <span class="item-num">{{ anchorDetail.sumBeFocused }}</span>
              <span class="item-desc">粉丝</span>
            </div>
            <div class="anchor-options-item" @click="showDownloadAppToast">
              <span class="item-num">{{ flowerCount }}</span>
              <span class="item-desc">送花</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <img class="square-img" src="~@/assets/image/square.png" alt="" />
        <div class="title" v-if="programList.length > 0">
          电台节目({{ programList.length }})
        </div>
        <div
          class="program-item"
          v-for="item in programList"
          :key="item.id"
          @click="toRecordProgram(item)"
        >
          <img :src="item.pictureUrl" alt="" />
          <div class="item-right">
            <span class="item-right-title">{{ item.name }}</span>
            <span class="item-right-intro">{{ item.intro }}</span>
            <span class="item-right-code">{{
              vadioStationCodeStr(item.radioStationCode)
            }}</span>
          </div>
          <div class="content-info-icon">
            <i class="play-icon v-icon-play-small" />
          </div>
        </div>
        <div class="columns-title" v-if="specialsList.length > 0">
          PGC专辑({{ specialsList.length }})
        </div>
        <div
          class="columns-item"
          v-for="item in specialsList"
          :key="item.id"
          @click="toColumnsDetail(item)"
        >
          <img :src="item.pictureUrl" alt="" />
          <div class="columns-item-right">
            <span class="columns-item-name">{{ item.name }}</span>
            <div class="columns-item-intro text-line-2">
              {{ item.intro }}
            </div>
          </div>
        </div>
        <div class="flowers-title">送花排行</div>
        <div class="flowers-wrapper">
          <img
            :src="item.publicImage"
            v-for="(item, index) in flowerUserList"
            :key="index"
            alt=""
          />
          <div class="tip-wrapper" @click="showDownloadAppToast">
            <span>查看送花排行榜</span>
            <i class="v-icon-arrow-right" />
          </div>
        </div>
        <div class="message-title">留言({{ commentListCount }})</div>
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了~"
          @load="onLoad"
        >
          <div class="message-item" v-for="item in commentList" :key="item.id">
            <div class="message-top">
              <img :src="item.formUserPublicImage" alt="" />
              <div class="message-top-right">
                <span class="message-nickname">{{
                  item.formUserNickName
                }}</span>
                <span class="message-time">{{ item.messageTime }}</span>
              </div>
            </div>
            <div
              class="message-content"
              v-html="useContentEmotion(item.content)"
            ></div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute, useRouter } from "vue-router";
import { computed, defineComponent, onMounted, ref } from "vue";
import JumpHeader from "@/components/Base/JumpHeader";
import emotionList from "@/assets/js/emotion.js";
import {
  queryAnchorDetails,
  queryPersonFlowersTopRank,
  selectProgramByHostUserId,
  queryAnchorSpecials,
  queryPersonMessageByPage,
} from "@/http/api";

export default defineComponent({
  name: "Anchor",
  components: {
    JumpHeader,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const finished = ref(false);
    const hostUserId = ref(0);
    const flowerCount = ref(0);
    const programList = ref([]);
    const commentList = ref([]);
    const anchorDetail = ref({});
    const specialsList = ref([]);
    const flowerUserList = ref([]);
    const commentListCount = ref(0);
    const _emotionList = emotionList;
    const codeStr = {
      962: "FM96.2",
      1027: "FM102.7",
      1061: "FM106.1",
      88: "FM88.0",
    };
    let page = 0;

    const getAnchorDetails = async () => {
      const { code, data } = await queryAnchorDetails({
        id: hostUserId.value,
      });
      if (code === "1") {
        anchorDetail.value = data;
      }
      console.log("主持人详情");
      console.log(data);
    };

    const getPersonFlowersTopRank = async () => {
      const { code, data, count } = await queryPersonFlowersTopRank({
        receiveUserId: hostUserId.value,
        topNum: 3,
      });
      if (code === "1") {
        flowerUserList.value = data;
      }
      flowerCount.value = count;
      console.log("送花排行帮");
      console.log(data);
    };

    const showDownloadAppToast = () => {
      Toast.fail("请先下载APP");
    };

    const getProgramByHostUserId = async () => {
      const { data } = await selectProgramByHostUserId({
        hostUserId: hostUserId.value,
      });
      if (data.code == 1) {
        programList.value = data.data;
      }
      console.log("电台节目");
      console.log(data);
    };

    const getAnchorSpecials = async () => {
      const { data } = await queryAnchorSpecials({
        id: hostUserId.value,
      });
      if (data.code === "1") {
        specialsList.value = data.data;
      }
      console.log("专辑");
      console.log(data);
    };

    const queryPersonMessage = async () => {
      const { code, data } = await queryPersonMessageByPage({
        toUserId: hostUserId.value,
        page: page,
        rows: 10,
      });
      loading.value = false;
      if (code === "1") {
        commentList.value = [...commentList.value, ...data.pageList];
        commentListCount.value = data.totalCount;
        if (data.totalPage <= page) {
          finished.value = true;
        }
      }
    };

    const toColumnsDetail = (item) => {
      router.push({
        name: "ColumnsDetail",
        query: {
          id: item.id,
        },
      });
    };

    const toRecordProgram = (item) => {
      router.push({
        name: "LivingDetail",
        query: {
          playType: "playRecord",
          code: item.radioStationCode,
          programId: item.id,
        },
      });
    };

    const onLoad = () => {
      page++;
      queryPersonMessage();
    };

    const bgImageStyle = computed(() => {
      let zIndex = 0;
      let paddingTop = "85%";

      return {
        zIndex,
        paddingTop,
        backgroundImage: `url(${anchorDetail.value.publicImage})`,
      };
    });

    // 转换emoji表情
    const useContentEmotion = (str) => {
      let tmp = "";
      let resultStr = "";
      const stack = [];

      for (const item of str) {
        if (item === "[") {
          stack.push(item);
        }
        if (stack.length) {
          stack.push(item);
          if (item === "]") {
            let emotion = stack.join("").slice(1);
            _emotionList.forEach((item) => {
              if (item.text === emotion) {
                let imgSrc = require(`@/assets/image/emotion/${item.name}.png`);
                tmp += `<img style="width: 22px; height: 22px; transform: translateY(5px);" src="${imgSrc}" />`;
              }
            });
            stack.length = 0;
          }
        } else {
          tmp += item;
        }
      }
      resultStr = tmp;

      return `<span style="line-height: 22px;">${resultStr}</span>`;
    };

    const vadioStationCodeStr = (code) => {
      return codeStr[code];
    };

    const wxShare = () => {
      const _anchorDetail = anchorDetail.value;
      wxSdk.getJSSDK({
        title: _anchorDetail.nickname,
        desc: _anchorDetail.description,
        linkurl: `https://app.gztv.com/hcfmshare/#/Anchor?id=${_anchorDetail.id}`,
        img: _anchorDetail.publicImage,
      });
    };

    onMounted(async () => {
      hostUserId.value = route.query.id;
      await getAnchorDetails();
      queryPersonMessage();
      getPersonFlowersTopRank();
      getProgramByHostUserId();
      getAnchorSpecials();
      wxShare();
    });

    return {
      onLoad,
      loading,
      finished,
      flowerCount,
      programList,
      commentList,
      anchorDetail,
      specialsList,
      bgImageStyle,
      flowerUserList,
      commentListCount,
      useContentEmotion,
      vadioStationCodeStr,
      showDownloadAppToast,
      toColumnsDetail,
      toRecordProgram,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-body {
  width: 100%;
  background: #fff;
  margin: 0 auto;
  max-width: 450px;

  .header {
    position: relative;
    width: 100%;
    transform-origin: top;
    background-size: cover;

    .filter {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(7, 17, 27, 0.5);
      backdrop-filter: blur(5px);
    }

    .anchor {
      position: absolute;
      top: 70px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 13px;

      .anchor-top {
        display: flex;
        align-items: center;

        & > img {
          width: 96px;
          height: 96px;
          border-radius: 50%;
          box-sizing: border-box;
          border: 1px solid #fff;
        }

        .anchor-info {
          display: flex;
          flex-direction: column;
          height: 96px;
          justify-content: space-between;
          margin-left: 10px;

          .anchor-name {
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            letter-spacing: 1px;
            text-indent: 1px;
          }

          .anchor-info-confirm {
            color: #fffefe;

            .v-icon-confirm {
              color: orange;
              margin-right: 5px;
            }
          }

          .options-btn {
            display: flex;
            align-items: center;

            .btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 80px;
              height: 30px;
              color: #fffefe;
              font-size: 14px;
              background: rgba(231, 56, 40, 0.9);
              border-radius: 15px;

              &:first-child {
                margin-right: 30px;
              }
            }
          }
        }
      }

      .anchor-desc {
        display: inline-block;
        font-size: 16px;
        color: #fffefe;
        margin-top: 20px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
      }

      .anchor-options {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .anchor-options-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          border-right: 1px solid rgba(255, 255, 255, 0.5);

          .item-num {
            font-size: 22px;
            font-weight: 500;
            color: #fff;
          }

          .item-desc {
            display: inline-block;
            margin-top: 10px;
            font-size: 14px;
            color: rgba(255, 254, 254, 0.8);
          }

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    background: #fff;

    .square-img {
      width: 100%;
      height: 13px;
      transform: translateY(-13px);
    }

    .title {
      padding-left: 13px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      text-indent: 1px;
    }

    .program-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 26px);
      margin: 0 auto;
      box-sizing: border-box;
      border: 1px solid #f1f1f1;
      border-radius: 8px;
      padding: 10px;
      margin-top: 15px;

      & > img {
        width: 80px;
        height: 80px;
        border-radius: 8px;
      }

      .item-right {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 80px;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 5px 0;
        margin-left: 15px;
        color: #111;

        .item-right-title {
          font-size: 16px;
          font-weight: bold;
          color: #111;
          letter-spacing: 1px;
          text-indent: 1px;
        }

        .item-right-intro {
          font-size: 14px;
          color: #999;
          letter-spacing: 1px;
          text-indent: 1px;
        }

        .item-right-code {
          font-size: 14px;
          color: #999;
          letter-spacing: 1px;
          text-indent: 1px;
        }
      }

      .content-info-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: rgba(240, 244, 249, 0.8);
        color: #666;
        border-radius: 50%;
        overflow: hidden;

        .play-icon {
          transform: translateX(2px);
        }
      }
    }

    .columns-title {
      padding-left: 13px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      text-indent: 1px;
      margin-top: 20px;
    }

    .columns-item {
      display: flex;
      align-items: center;
      width: calc(100% - 26px);
      margin: 0 auto;
      background: rgba(200, 200, 200, 0.2);
      padding: 10px;
      border-radius: 8px;
      margin-top: 15px;
      box-sizing: border-box;

      img {
        width: 80px;
        height: 80px;
        min-width: 80px;
        border-radius: 8px;
      }

      .columns-item-right {
        display: flex;
        flex-direction: column;
        height: 80px;
        margin-left: 10px;
        padding-top: 5px;
        box-sizing: border-box;

        .columns-item-name {
          font-size: 16px;
          color: #111;
        }

        .columns-item-intro {
          font-size: 14px;
          color: #999;
          padding-top: 8px;
          line-height: 18px;
        }
      }
    }

    .flowers-title {
      padding-left: 13px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      text-indent: 1px;
      margin-top: 20px;
    }

    .flowers-wrapper {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 0 13px;
      margin-top: 15px;

      & > img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }

      .tip-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        color: #999;
        font-size: 14px;

        .v-icon-arrow-right {
          fot-size: 18px;
        }
      }
    }

    .message-title {
      padding-left: 13px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      text-indent: 1px;
      margin-top: 20px;
    }

    .message-item {
      width: calc(100% - 26px);
      margin: 15px auto 0;
      box-sizing: border-box;
      padding: 0 13px 15px;
      border-bottom: 1px solid #f5f5f5;

      .message-top {
        display: flex;
        align-items: center;

        & > img {
          width: 55px;
          height: 55px;
          border-radius: 50%;
        }

        .message-top-right {
          display: flex;
          flex-direction: column;
          height: 60px;
          justify-content: space-between;
          margin-left: 10px;
          box-sizing: border-box;
          padding: 10px 0;

          .message-nickname {
            font-size: 16px;
            color: #111;
            font-weight: bold;
          }

          .message-time {
            font-size: 12px;
            color: #999;
          }
        }
      }

      .message-content {
        font-size: 16px;
        color: #333;
        margin-top: 5px;
      }
    }
  }
}
</style>
